import React, { Component } from 'react';

import LocationInput from './SearchInput/LocationInput';
import FlightTypeInput from './SearchInput/FlightTypeInput';
import NationalityInput from './SearchInput/NationalityInput';
import DateInput from './SearchInput/DatePicker';
import PassengerInput from './SearchInput/PassengerInput';
import SearchButtonWithRouter from './SearchInput/SearchButtonWithRouter';

import './Flights.css';

class FlightSearch extends Component {
  render() {
    return (
      <section className="flight-search">
        <div className="white-panel">
          <h2>
            Flights{' '}
            <span className="d-none d-md-block">
              <img
                src="https://s3.amazonaws.com/honeyguide/assets/himalayan-logo.png"
                alt="HBL"
                style={{ width: '100px', marginRight: '10px' }}
              />
              <img
                src="https://s3.amazonaws.com/honeyguide/assets/powered_by_stripe.png"
                alt="STRIPE"
                style={{ width: '100px' }}
              />
            </span>
          </h2>
          {/* <div className="row">
            <div className="col-md-12 col-12" />
          </div> */}
          <div className="row d-flex align-items-end">
            <div className="col-md-4 col-12 line-padding v-line">
              <FlightTypeInput />
              <LocationInput />
            </div>
            <div className="col-md-4 col-12 line-padding v-line">
              <div className="d-none d-md-block">
                <br />
                <br />
                <p />
              </div>
              <DateInput />
            </div>
            <div className="col-md-4 col-12 line-padding v-line">
              <div className="row">
                <NationalityInput />
                <PassengerInput />
              </div>
            </div>
          </div>
          <div className="action-btn-wrap">
            <SearchButtonWithRouter />
          </div>
        </div>
      </section>
    );
  }
}

export default FlightSearch;



// WEBPACK FOOTER //
// ./src/components/Flights/FlightSearch.jsx